import { render, staticRenderFns } from "./ShareItems.vue?vue&type=template&id=6138ed43"
import script from "./ShareItems.vue?vue&type=script&lang=js"
export * from "./ShareItems.vue?vue&type=script&lang=js"
import style0 from "./ShareItems.vue?vue&type=style&index=0&id=6138ed43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports